import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';

const ShareTitle = ({ share }) => {
  const files = share.files_count - share.links_count;

  const intl = useIntl();

  return (
    <div>
      {share.top_collection && (
        <>
          <h3 className="share-title">
            {share.top_collection.name}
          </h3>
          {share.top_collection.description && (
            <h6 className="share-description">
              {share.top_collection.description}
            </h6>
          )}
        </>
      )}
      <h5 className="share-subtitle">
        {intl.formatMessage(
          { defaultMessage: '{isTopCollection, select, yes {Containing } other {}}{hasFiles, select, yes {{files} {files, plural, one {file} other {files}}} other {}}{hasMore, select, yes { and } other {}}{hasLinks, select, yes { {linksCount} {linksCount, plural, one {link card} other {link cards}}} other {}}{hasTopCollections, select, yes { in {topCollectionsCount} {topCollectionsCount, plural, one { collection } other { collections }}} other {}}{isTopCollection, select, yes {} no { shared} other {}}' },
          {
            isTopCollection: share.top_collection,
            hasFiles: files > 0 || share.links_count === 0 ? 'yes' : 'no',
            hasMore: files > 0 && share.links_count > 0 ? 'yes' : 'no',
            files,
            hasLinks: share.links_count > 0 ? 'yes' : 'no',
            linksCount: share.links_count,
            hasTopCollections: share.top_collections_count > 1 ? 'yes' : 'no',
            topCollectionsCount: share.top_collections_count,
          },
        )}
      </h5>
      {share.comment && (
        <p className="share-comment">
          {share.comment}
        </p>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  filesParams: state.Files.params,
  profile: state.Auth.profile,
});

ShareTitle.propTypes = {
  share: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(ShareTitle);
